import React from 'react';
import { Button } from '../../../../components';

import css from './SectionJoinUs.css';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';

export default ({ history }) => (
    <section className={css.root}>
        <div className={css.content}>
            <h2 className={css.subHeading}>Kostenlos registrieren</h2>
            <p className={css.heading}>Werde Teil der Community</p>
            <p>
                Werde Teil unserer Community und erhalte einen kostenlosen Zugang zu
                hundertenPferdemenschen und Pferden mit wenigen Klicks. Leg heute noch los!
            </p>
        </div>
        <footer className={css.footer}>
            <Button
                type="button"
                className={css.subLinkPrimary}
                onClick={() =>
                    history.push(createResourceLocatorString('SignupPage', routeConfiguration()))
                }
            >
                Kostenlos registrieren
            </Button>
        </footer>
    </section>
);
